import React, { useState, useEffect } from 'react';
import styles from '../../css/Range.module.css';
import MultiRangeSlider from '../../component/MultiRangeSlider';

export default function RangeControl({
	setCurrentBase,
	searchType,
	setSearchType,
	state,
  setState,
  setRangeMin,
  setRangeMax,
  rangeMin,
  rangeMax,
  handleRangeChange
}) {

  let minText = 0;
  let maxText = 0;
  const [selectType, setSelectType] = useState(searchType);
  
  const init = () => {
    minText = 0;
    if (selectType == "num") {
      maxText = 1640;
    } else if (selectType == "omega") {
      maxText = 50;
    } else if (selectType == "pay") {
      maxText = 84000;
    }
  }

  init();

	const handleSelect = (type) => {
    setRangeMin(0);
    if (type == "상점") {  
      setRangeMax(1640);    
      setSelectType('num');
    } else if (type == "회복") {
      setRangeMax(50);
      setSelectType('omega');
    } else if (type == "매출") {
      setRangeMax(84000);
      setSelectType('pay');
    }
  };

  const handleRange = (min, max) => {
    setRangeMin(min);
    setRangeMax(max);    
  };

  const handleConfirm = () => {
    if (selectType == "num") {
      setCurrentBase('상점수');
      setSearchType('num');
    } else if (selectType == "omega") {
      setCurrentBase('회복탄력성');
      setSearchType('omega');
    } else if (selectType == "pay") {
      setCurrentBase('매출액(백만원)');
      setSearchType('pay');
    }

    handleRangeChange();
    setState({ ...state, range: !state.range, toggle: false });
  }
	
	return (
		<>
			{
				state.range &&
				<div className={`${styles.wrap} ${state.toggle? styles.contentsMove : styles.contents}`}>
					<div className={styles.rangeBox}>
            <ul>
              <li>
                <input type='radio'
                  name='cluster'
                  id='num'
                  onChange={(e) => handleSelect('상점')}
                  checked={selectType === 'num'}
                />
                <label htmlFor='num'>상점수</label>
              </li>
              <li>
                <input type='radio'
                  name='cluster'
                  id='omega'
                  onChange={(e) => handleSelect('회복')}
                  checked={selectType === 'omega'}
                />
                <label htmlFor='omega'>회복탄력성</label>
              </li>
              <li>
                <input type='radio'
                  name='cluster'
                  id='pay'
                  onChange={(e) => handleSelect('매출')}
                  checked={selectType === 'pay'}
                />
                <label htmlFor='pay'>매출액(백만원)</label>
              </li>
            </ul>
            
            <MultiRangeSlider
              min={minText}
              max={maxText}
              rangeMin={rangeMin}
              rangeMax={rangeMax}
              setRangeMin={setRangeMin}
              setRangeMax={setRangeMax}
              onChange={({ min, max }) => handleRange(min, max)}
            />

            <button type='submit' className={styles.confirm} onClick={handleConfirm}>확인</button>
					</div>
				</div>
			}
		</>
	)
}

